"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHOptions = void 0;
const KHLocalStorageWrapper_1 = require("./KHLocalStorageWrapper");
class KHOptions extends KHLocalStorageWrapper_1.KHLocalStorageWrapper {
    constructor(key, objectReferences = []) {
        super(key);
        this.objectReferences = new Map();
        for (let i = 0; i < objectReferences.length; i++) {
            this.objectReferences.set(objectReferences[i].key, objectReferences[i]);
            objectReferences[i].options = this;
        }
        this.load();
    }
    load() {
        const json = super.load();
        this.objectReferences.forEach((value) => {
            value.setFromJson(json);
        });
    }
    /**
     * Saves the state to local storage. Returns whether or not save was successful.
     */
    save() {
        let json = {};
        this.objectReferences.forEach((value) => {
            value.addToJson(json);
        });
        return super.save(json);
    }
    reset() {
        super.save({});
        this.load();
    }
    get(key) {
        return this.objectReferences.get(key);
    }
}
exports.KHOptions = KHOptions;
// export const global_options = FBDOptions.Load();
